import {
  CommunityFeedFilters,
  CommunityMemberType,
  CommunityPostStatus,
} from 'generated/graphql';

export type FeedTab = 'all' | 'mine' | 'drafts' | 'scheduled';

// community-service rejects a search of fewer than 3 characters, so a shorter
// term is treated as no text filter at all.
export const MIN_SEARCH_LENGTH = 3;

export const isOwnerQueueTab = (tab: FeedTab): boolean =>
  tab === 'drafts' || tab === 'scheduled';

const STATUSES_BY_TAB: Partial<Record<FeedTab, CommunityPostStatus[]>> = {
  drafts: [CommunityPostStatus.Draft],
  scheduled: [CommunityPostStatus.Scheduled],
};

export const toCommunityFeedFilters = (
  tab: FeedTab,
  ownerId: number | null,
  search = '',
): CommunityFeedFilters | undefined => {
  const trimmedSearch = search.trim();

  const authorFilter: CommunityFeedFilters =
    tab === 'mine' && ownerId !== null
      ? {
          authors: [
            { memberType: CommunityMemberType.Creator, memberId: ownerId },
          ],
        }
      : {};
  const searchFilter: CommunityFeedFilters =
    trimmedSearch.length >= MIN_SEARCH_LENGTH ? { search: trimmedSearch } : {};
  const statuses = STATUSES_BY_TAB[tab];
  const statusFilter: CommunityFeedFilters = statuses ? { statuses } : {};

  const filters: CommunityFeedFilters = {
    ...authorFilter,
    ...searchFilter,
    ...statusFilter,
  };
  return filters.authors || filters.search || filters.statuses
    ? filters
    : undefined;
};
